
import request from '@/utils/request'
// 字典
export function getDictList(data) {
  return new Promise((resolve, reject) => {
    request.get('/ha-base/dict/list', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取机构列表
export function getTenantList(data) {
  return new Promise((resolve, reject) => {
    request.get('/ha-base/tenant/select', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 馆藏分类
export function getCategoryTree(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/category/tree', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 学科接口
export function getSubjectTree(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/subject/tree', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 专题下拉列表
export function getTopicTree(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/topic/list', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 应用下拉表接口
export function getCloudclientList(data) {
  return new Promise((resolve, reject) => {
    request.get('/ha-base/cloudclient/list', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 用户类型
export function getUserTypeList(data) {
  return new Promise((resolve, reject) => {
    request.get('/ha-base/userType/list', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 行政区域树
export function getRegiontree() {
  return new Promise((resolve, reject) => {
    request.get('/ha-base/region/treeUpperCity').then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 体裁分类树
export function getGenreTree() {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/genre/tree').then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
